import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/OfficialDoc`
//#region select数据源相关api
const GetInfo = (id: number) => `${apiUrl}/${id}`
const GetList = `${apiUrl}`
const Delete = (id: number) => `${apiUrl}/${id}`
const GetByCheck = `${apiUrl}/GetByCheck`
const PostData = `${apiUrl}`
//#endregion

export const emptyData: OfficialDocData = {
    Id: 0,
    PublicType: 0,
    DocType: 0,
    DocYear: '',
    DocSerialNo: '',
    DocCategory: 0,
    DocTitle: '',
    DocCompileNo: '',
    DocReleaseUnit:0,
    DocContent: '',
    Description: '',
    ApproveDate: new Date(),
    Inactive: false,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    PublicTypeName: '',
    DocTypeName: '',
    CategoryName: '',
    AttachType: 0,
    AttachGuid: ''
}
export interface OfficialDocData {
    Id: number
    PublicType: number
    DocType: number
    DocYear: string
    DocSerialNo: string
    DocCategory: number
    DocTitle: string
    DocCompileNo: string
    DocReleaseUnit:number
    DocContent: string
    Description: string
    ApproveDate: Date
    Inactive: boolean
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    PublicTypeName: string
    DocTypeName: string
    CategoryName: string

    AttachType: number
    AttachGuid: string
}
export const getByCheck = (type: number, year: string, num: string) => {
    return tryAxios({
        method: 'get',
        url: GetByCheck,
        params: {
            docType: type,
            docYear: year,
            docNum: num
        }
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id)
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const postData = (form: OfficialDocData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}